<div class="toast toast-{{ toast.type }}" [style.bottom.px]="counter * 100">
  <div class="flex">
    <div class="ml-3">
      <h3 data-testid="notification-title" class="text-sm font-medium">{{ toast.title }}</h3>
      <div class="mt-2 text-sm">
        <p data-testid="notification-body" class="truncate">{{ toast.body }}</p>
      </div>
    </div>
    <div class="ml-auto pl-3">
      <div class="dismiss-wr">
        <button type="button" class="reset-btn" (click)="remove.emit(counter)">
          <span data-testid="notification-close" class="sr-only">{{ 'MODALBOXES.DISMISS' | translate }}</span>
          <svg viewBox="0 0 20 20" aria-hidden="true">
            <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
